import {
  deleteNotification,
  getNotifications,
  Notification,
} from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

export function useNotificationsMobile() {
  const { lang } = useContext(PspContext);

  const [notifications, setNotifications] = useState<Notification[]>();
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);

  useEffect(() => {
    setIsLoadingNotifications(true);
    getNotifications({ query: { limit: 100, offset: 0 } }).then(
      ({ data, error }) => {
        if (error) {
          toast(translate("somethingWentWrong", lang));
          setIsLoadingNotifications(false);
          setSomethingWentWrong(true);
        } else {
          setNotifications(data);
          setIsLoadingNotifications(false);
        }
      },
    );
  }, [lang]);

  const isLoading = isLoadingNotifications;

  return {
    notifications,
    somethingWentWrong,
    isLoading,
  };
}
